export default __webpack_public_path__ + "static/media/waa-alert-circle.ef2adc75.svg";